import { createContext, useContext } from "react";
import type { EventApiResponse } from "@/lib/humhub-api/types";

interface EventLinkPreviewContextValue {
  onEventClick?: (eventData: EventApiResponse) => void;
  currentStudyGroupId?: string;
}

const EventLinkPreviewContext = createContext<EventLinkPreviewContextValue>({});

interface EventLinkPreviewProviderProps {
  onEventClick?: (eventData: EventApiResponse) => void;
  currentStudyGroupId?: string;
  children: React.ReactNode;
}

export const EventLinkPreviewProvider: React.FC<
  EventLinkPreviewProviderProps
> = ({ onEventClick, currentStudyGroupId, children }) => {
  return (
    <EventLinkPreviewContext.Provider
      value={{ onEventClick, currentStudyGroupId }}
    >
      {children}
    </EventLinkPreviewContext.Provider>
  );
};

export const useEventLinkPreviewContext = (): EventLinkPreviewContextValue => {
  return useContext(EventLinkPreviewContext);
};
